import React, {Component} from "react";
import {injectIntl} from "react-intl";
import AssignSafeModal from "../safe/AssignSafeModal";
import {connect} from "react-redux";
import {withAuthorization} from "../../../services/Authorization";
import Signature from "./Signature";
import Constants from "../../../services/Constants";
import Safe from "./Safe";
import Intervention from "../../../services/Intervention";

class OutsideBusinessHour extends Component {

  showModal = () => {
    const {type} = this.props;
    this.props.showSafeAssignModal(type);
  };

  hideModal = () => {
    this.props.hideSafeAssignModal();
  };

  on247Select = () => {
    const {selectable, selected, onSelect} = this.props;
    if (!selected && onSelect && selectable) {
      onSelect();
    }
  };

  isSafeNeeded = () => {
    const {intervention: {journey: {properties}}, type} = this.props;

    if (!properties.mobility){
      return false;
    }
    if (type === Constants.DROPOFF_247) {
      // drop off always required safe, as the key has to be dropped inside a safe
      return true;
    } else if (type === Constants.PICKUP_247) {
      // pickup always require a safe (to get customer key)
      return true;
    }
    return false;
  };

  render() {
    const {intl: {formatMessage}, type, selected, signature, assignJourneySafe: {showModal}, canWrite} = this.props;
    const {intervention, intervention: {journey: {dropOffSafe, pickupSafe}}} = this.props;
    const selectedCss = selected === true ? undefined : "choice-card--unselected";

    if (!type) {
      return null;
    }

    const selectedSafe = (type === Constants.DROPOFF_247 ? dropOffSafe : pickupSafe);
    const canAssignSafe = (canWrite && Intervention.isConfirmed(intervention));
    return (
      <div>
        <div className={["choice-card", selectedCss].join(' ')} onClick={this.on247Select}>
          <header className="choice-card__header">
            <h4 className="choice-card__title">{formatMessage({id: '24/7'})}</h4>
          </header>
          <div className="choice-card__body">
            {selected &&
              <div>
                <Signature signature={signature}/>
                <br/>
                {this.isSafeNeeded() &&
                  <Safe onClick={this.showModal} intervention={intervention} safe={selectedSafe} type={type} canWrite={canAssignSafe}/>
                }
                {showModal[type] && <AssignSafeModal visible={showModal[type]} onModalClose={this.hideModal} type={type} intervention={intervention}/>}
              </div>
            }
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  assignJourneySafe: state.assignJourneySafe
});

const mapDispatchToProps = dispatch => ({
  showSafeAssignModal: (safeType) => dispatch({type: 'SHOW_ASSIGN_SAFE_MODAL', safeType}),
  hideSafeAssignModal: () => dispatch({type: 'HIDE_ASSIGN_SAFE_MODAL'})
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withAuthorization(injectIntl(OutsideBusinessHour), ['DUI_ADMIN', 'DUI_SERVICE_ADVISOR']));



// WEBPACK FOOTER //
// ./src/components/interventiondetail/reception/OutsideBusinessHour.js